import {TweenMax, Linear} from "gsap";
import BaseMobileAutoPlayPanelContainer from "Base/uiMobile/autoPlayPanel/BaseMobileAutoPlayPanelContainer";

export default class BaseMobileLandscapeAutoPlayPanelContainer extends BaseMobileAutoPlayPanelContainer {
    constructor(data, displayData) {
        super(data, displayData);
    }

    createTweens() {
        this.openTween = TweenMax.to(this.content, 0.1, {x:0, ease:Linear.easeNone, paused:true});
        this.closeTween = TweenMax.to(this.content, 0.1, {x:340, ease:Linear.easeNone, paused:true});
    }
}